import { Board } from "../../freelo";
import { IConverter, TSnapshot } from "../generics";

export const boardConverter: IConverter<Board> = {
  toFirestore(board: Omit<Board, "id">) {
    return {
      name: board.name,
      order: board.order,
      createdAt: board.createdAt,
      updatedAt: board.updatedAt,
      createdBy: board.createdBy,
      readUserIds: board.readUserIds,
      writeUserIds: board.writeUserIds,
      listOrder: board.listOrder,
      backgroundUrl: board.backgroundUrl,
      projectId: board.projectId,
      clientId: board.clientId,
      associatedStudentIds: board.associatedStudentIds,
      associatedCohortIds: board.associatedCohortIds,
      isPrimaryBoardForCohort: board.isPrimaryBoardForCohort,
      mentorId: board.mentorId,
      repositoryOwner: board.repositoryOwner,
      repositoryName: board.repositoryName,
      repositoryUrl: board.repositoryUrl,
    };
  },
  fromFirestore(snapshot: TSnapshot) {
    const data = snapshot.data() as Board;
    return {
      id: snapshot.id,
      name: data?.name,
      order: data?.order,
      createdAt: data?.createdAt,
      updatedAt: data?.updatedAt,
      createdBy: data?.createdBy,
      readUserIds: data?.readUserIds,
      writeUserIds: data?.writeUserIds,
      listOrder: data?.listOrder,
      backgroundUrl: data?.backgroundUrl,
      projectId: data?.projectId,
      clientId: data?.clientId,
      associatedStudentIds: data?.associatedStudentIds,
      associatedCohortIds: data?.associatedCohortIds,
      isPrimaryBoardForCohort: data?.isPrimaryBoardForCohort,
      mentorId: data?.mentorId,
      repositoryOwner: data?.repositoryOwner,
      repositoryName: data?.repositoryName,
      repositoryUrl: data?.repositoryUrl,
    };
  },
};
